module.exports = __webpack_public_path__ + "static/media/graphql.7fb2e412.svg";